import { appConfig } from '../../config/appConfig';
import {
  getRequiredPermissions,
  buildPermissionCopy,
  requestMotionPermissionIfNeeded,
} from '../../utils/permissions';
import { permissionsGranted, permissionDenied } from '../../state/appState';
import { logger } from '../../utils/logger';

// Permission prep screen — PERMISSION_PREP state.
// Explains which permissions are needed and presents a CTA.
//
// Camera is NOT requested here. It is opened once inside startARSession so
// the browser only shows one camera prompt, in the correct context.
//
// iOS motion permission IS requested here because it must come from a direct
// user gesture before the AR session starts.

export function renderPermissionPrepScreen(root: HTMLElement): void {
  const perms = getRequiredPermissions();
  const copy = buildPermissionCopy(perms);

  root.innerHTML = `
    <div class="intro-screen">
      <!-- Top-left museum logo area -->
      <div class="intro-logo" aria-label="Sag Harbor Whaling and Historical Museum">
        <img src="/assets/logo.png" alt="Museum Logo" />
        <!--
        <div class="intro-logo__mark"></div>
        <span class="intro-logo__text">Sag Harbor<br>Whaling &amp; Historical Museum</span>
        -->
      </div>

      <div class="intro-content">
        <p class="intro-tagline">Begin by scanning the sign with your camera on the next screen.</p>
        <p class="intro-tagline">${copy}</p>
      </div>

      <div class="intro-footer">
        <button
          class="intro-cta"
          id="grant-permission-btn"
          type="button"
          aria-label="${appConfig.copy.beginCta}"
        >
          ${appConfig.copy.beginCta}
        </button>
      </div>
    </div>
  `;

  const btn = root.querySelector<HTMLButtonElement>('#grant-permission-btn');
  if (btn) {
    btn.addEventListener('click', async () => {
      btn.disabled = true;

      // Request motion permission if the platform requires it (iOS only).
      // Camera is opened later by startARSession — one prompt, correct context.
      const motionOk = await requestMotionPermissionIfNeeded(perms);
      if (!motionOk) {
        logger.log('Motion permission denied');
        permissionDenied();
        return;
      }

      logger.log('Pre-flight permissions ok, starting AR');
      permissionsGranted();
    }, { once: true });
  }
}
